import { Link } from "react-router-dom";

function TermsAndConditionsPage() {
  return (
    <>
      <h1>Opći uvjeti poslovanja</h1>
      <p>
        (dalje u tekstu: Uvjeti) platforme Lumen@home (dalje u tekstu: Lumen) od
        12.9.2024
      </p>
      <hr />
      <h4>1. DEFINICIJE</h4>
      <p>
        1.1. Korisnikom se smatra svaka osoba koja zakaže poduke ili pripreme za
        maturu na internetskoj stranici lumenathome.com (dalje u tekstu:
        Korisnik).
        <br />
        1.2. Davatelj usluga online instrukcija je obrt LUMEN (dalje u tekstu:
        Lumen).
      </p>
      <h4>2. UVOD</h4>
      <p>
        2.1. Lumen redovito posluje pod Uvjetima navedenima u nastavku. Ovi
        Uvjeti predstavljaju ponudu platforme Lumen i uobičajeni način
        poslovanja. Uvjetima su opisani i uređeni prava i obveze između
        Korisnika i Lumena. Na svako zakazivanje poduka ili priprema primjenjuju
        se Uvjeti objavljeni u trenutku zakazivanja usluge neovisno o kasnijim
        izmjenama.
        <br />
        2.2. Uvjeti su javno objavljeni i dostupni na internetskoj stranici
        lumenathome.com (dalje u tekstu: Internet stranica). Lumen može
        izmjeniti Uvjete bez prethodnog pristanka Korisnika. Izmijenjeni Uvjeti
        stupaju na snagu danom objave na Internetskoj stranici.
        <br />
        2.3. Prihvaćanjem ovih Uvjeta klikom na kućicu pored njih prilikom
        zakazivanja poduka ili priprema potvrđujete da ste se upoznali sa
        sadržajem i značenjem odredbi ovih Uvjeta te da ih u cijelosti
        prihvaćate.
      </p>
      <h4>3. PREDMET USLUGA</h4>
      <p>
        3.1. Lumen omogućuje Korisnicima pohađanje online poduka i priprema za
        maturu koje pružaju instruktori (dalje u tekstu: Usluga).
        <br />
        3.2.1. Poduke
        <br />
        U slučaju zakazivanja poduke, korisniku su vidljivi svi dostupni termini
        po mjesecu za instruktora.
        <br />
        3.2.2. Pripreme za maturu
        <br />U slučaju zakazivanja priprema za maturu, korisniku su vidljivi
        dostupni termini po predmetima. U slučaju nepopunjavanja grupe, Lumen
        zadržava pravo otkazati pripreme. Lumen zadržava pravo promijeniti
        instruktora koji će održavati pripreme. Predmeti iz kojih se mogu
        zakazati poduke:
        <ul>
          <li>Matematika</li>
          <li>Engleski jezik</li>
          <li>Kemija</li>
          <li>Fizika</li>
          <li>Biologija</li>
          <li>Latinski jezik</li>
          <li>Razredna nastava (od 1. do 4. razreda)</li>
          <li>Hrvatski jezik</li>
          <li>Informatika</li>
        </ul>
        Predmeti za koje se mogu zakazati pripreme za državnu maturu su:
        <ul>
          <li>Fizika</li>
          <li>Matematika A (viša razina)</li>
          <li>Matematika B (osnovna razina)</li>
          <li>Hrvatski jezik</li>
        </ul>
      </p>
      <h4>3.3. Korisnički račun</h4>
      <p>
        Korisnik može koristiti Usluge Lumena nakon registracije, odnosno
        kreiranja korisničkog računa na internetskoj stranici prilikom ili nakon
        zakazivanja instrukcija. Kako bi proveo registraciju, Korisnik mora
        unijeti adresu elektroničke pošte i zaporku. Potom se kreira njegov
        korisnički račun kojem može pristupiti, odnosno prijaviti se svaki put
        kad koristi Internet stranicu.
        <br />
        Podaci koje Korisnik navede u korisničkom profilu moraju biti točni i
        potpuni. Korisnik snosi odgovornost i potencijalne troškove uslijed
        poteškoće ili nemogućnosti isporuke Usluge u slučaju prikazivanja
        netočnih, odnosno nepotpunih podataka. Korisnik može u bilo kojem
        trenutku pristupiti i mijenjati osobne podatke dostupne unutar svog
        korisničkog računa. Korisniku su dostupne i informacije o predstojećim
        Uslugama koje ne može mijenjati – link na Zoom podatke o naručenom
        terminu, instruktoru za poduke te terminu za pripreme.
      </p>
      <h4>4. NARUDŽBA</h4>
      <p>
        4.1. Zakazivanje termina za poduke ili pripreme za maturu od strane
        Korisnika preko Internetske stranice smatra se narudžbom.
        <br />
        4.2. Lumen pruža Uslugu u skladu s narudžbom koju Korisnik dostavlja
        putem Internetske stranice. Naručitelj je dužan jasno navesti sve
        relevantne informacije vezane uz instrukcije unutar narudžbe te pružiti
        svu potrebnu pomoć i informacije kako bi se usluga mogla odviti bez
        poteškoća.
        <br />
        4.3. Korisnik ima pravo zatražiti izmjenu narudžbe za državnu maturu
        pisanim putem na email mia@lumenathome.com, a izmjenu narudžbe za poduke
        na e-mail lumenpoduke@gmail.com. Lumen ima pravo odbiti uslugu ako
        Korisnik naknadno poželi promijeniti detalje narudžbe kao što je termin
        ili instruktor.
        <br />
        4.4. Za nesmetano izvođenje naručene usluge, Naručitelj prethodno mora
        osigurati odgovarajuću opremu, uključujući računalo s internetskim
        preglednikom i stabilnom internetskom vezom, po mogućnosti web kameru,
        mikrofon i slušalice. U slučaju da Naručitelj ne posjeduje potrebnu
        opremu, usluga ovisno o okolnostima slučaja možda neće moći biti
        izvršena te ju u tom slučaju Lumen nije dužan izvršiti u nakadnom roku.
      </p>
      <h4>5. CIJENE I PLAĆANJE</h4>
      <p>
        5.1. Cjenik Lumena dostupan je na na naslovnoj stranici i na izbornoj
        traci platforme pod “Cjenik” ili na poveznici{" "}
        <Link to="https://www.lumenathome.com/cjenik">
          https://www.lumenathome.com/cjenik
        </Link>
        . Cijene na Internetskoj stranici izražene su u eurima (EUR).
        <br />
        5.2. Lumen zadržava pravo promjene cijena u bilo kojem trenutku, a sve
        promjene bit će pravovremeno objavljene na Internetskoj stranici.
        Promjene cijena ne utječu na već zakazane i plaćene termine instrukcija.
        <br />
        5.3. Cjenik uključuje sve relevantne informacije o troškovima usluga, a
        Korisnici su obavezni provjeriti važeće cijene prije zakazivanja
        termina.
        <br />
        5.4. Korisnik je dužan izvršiti plaćanje za poduku prilikom zakazivanja
        termina za poduke. Korisnik je dužan izvršiti plaćanje za pripreme
        najkasnije pet dana prije održavanja priprema za koje je podnio
        narudžbu.
        <br />
        5.5. Plaćanje se obavlja putem internet bankarstva koristeći siguran
        sustav za plaćanje Monri, pri čemu su svi podaci enkriptirani radi
        zaštite privatnosti i sigurnosti Korisnika. Moguće je plaćati
        Mastercard, Maestro, Visa, Visa Premium, Diners, JCB i Discover
        karticama jednokratno ili otplatom na rate po trenutno važećim uvjetima
        Monri sustava za plaćanje.
        <br />
        5.6. Ugovor o pružanju usluga između Korisnika i Lumena smatra se
        sklopljenim kada Naručitelj primi na svoju e-mail adresu mail s naslovom
        „Potvrda rezervacije“.
      </p>
      <h4>6. PRIGOVORI</h4>
      <p>
        6.1. Prigovori koji se tiču priprema za maturu podnose se na e-mail
        mia@lumenathome.com, a prigovori koji se tiču poduka na e-mail
        lumenpoduke@gmail.com.
        <br />
        6.2. Korisnik je dužan u roku od 24 sata nakon izvršenih poduka ili
        priprema obavijestiti Lumen o nezadovoljstvu uslugom i jasno ga
        obrazložiti. Lumen će bez odgađanja potvrditi primitak prigovora.
        Poželjno je dostaviti dokaze kako bi se reklamacija brže i kvalitetnije
        obradila.
        <br />
        6.3. Lumen će Korisniku odgovoriti u roku od 15 dana od dana zaprimanja
        prigovora te se izjasniti prihvaća li osnovanost prigovora Korisnika.
      </p>
      <h4>7. RASKID UGOVORA</h4>
      <p>
        7.1. Korisnik može raskinuti ugovor o pružanju usluga poduka te otkazati
        ugovor o pružanju usluga priprema za maturu.
        <br />
        7.2. U slučaju da Korisnik želi otkazati zakazani termin poduke, povrat
        uplaćenog iznosa bit će obračunat prema sljedećim uvjetima:
        <br />
        • Ako se poduka otkaže tjedan dana (7 dana) ili više prije zakazanog
        termina, Korisniku će biti vraćeno 50% uplaćenog iznosa.
        <br />
        • Ako se poduka otkaže tri dana (3 dana) prije zakazanog termina,
        Korisniku će biti vraćeno 30% uplaćenog iznosa.
        <br />
        • Ako se poduka otkaže manje od tri dana prije zakazanog termina ili se
        Korisnik ne pojavi na zakazanom terminu, povrat sredstava neće biti
        moguć.
        <br />
        Ovi uvjeti povrata sredstava primjenjuju se kako bi se pokrili troškovi
        organizacije i rezervacije termina.
        <br />
        7.3. U slučaju da Korisnik želi otkazati zakazanu pripremu, povrat
        uplaćenog iznosa bit će obračunat prema sljedećim uvjetima:
        <br />
        Ako se priprema otkaže dva tjedna (14 dana) ili više prije zakazanog
        termina, Korisniku će biti vraćen puni iznos uplate.
        <br />
        Ako se priprema otkaže unutar razdoblja između dva tjedna (14 dana) i
        tri dana (3 dana) prije zakazanog termina, Korisniku će biti vraćeno 50%
        uplaćenog iznosa.
        <br />
        Ako se priprema otkaže manje od tri dana prije zakazanog termina ili se
        Korisnik ne pojavi na zakazanom terminu, povrat sredstava neće biti
        moguć.
      </p>
      <h4>8. VIŠA SILA</h4>
      <p>
        8.1. Ni Korisnik ni Lumen neće biti odgovorni za neizvršenje ili
        kašnjenje u izvršenju bilo koje obveze prema ovim Uvjetima ako je takvo
        neizvršenje ili kašnjenje uzrokovano događajima izvan razumne kontrole
        strane koja se poziva na višu silu ("Viša sila"). Događaji Više sile
        uključuju, ali nisu ograničeni na, prirodne katastrofe, rat,
        terorističke napade, građanske nemire, vladine akcije, epidemije,
        pandemije, kvarove u telekomunikacijskoj mreži, strujne udare, cyber
        napade, kao i bilo koje druge događaje koji mogu ometati ili onemogućiti
        pružanje ili korištenje usluga.
        <br />
        8.2. Strana pogođena događajem Više sile dužna je čim prije obavijestiti
        drugu stranu o prirodi događaja i mjerama koje poduzima za prevladavanje
        situacije. Za vrijeme trajanja Više sile, sve obveze prema ovim Uvjetima
        bit će suspendirane do prestanka djelovanja Više sile, nakon čega će se
        izvršenje obveza nastaviti u najkraćem mogućem roku.
        <br />
        8.3. Ako događaj više sile traje duže od 30 dana, bilo koja strana ima
        pravo raskinuti ugovor bez obveze naknade štete drugoj strani. U slučaju
        raskida ugovora zbog Više sile, Korisniku će na njegov zahtjev biti
        omogućeno vraćanje uplaćenih sredstava za neiskorištene usluge, dok će
        Lumen biti oslobođen obveze daljnjeg pružanja usluga.
      </p>
      <h4>9. PRIVATNOST I ZAŠTITA PODATAKA</h4>
      <p>
        Lumen poštuje privatnost korisnika i obvezuje se čuvati osobne podatke u
        skladu s važećim zakonima o zaštiti podataka. Detaljne informacije o
        prikupljanju, obradi i zaštiti osobnih podataka nalaze se u našoj{" "}
        <Link to="/politika-privatnosti">Politici privatnosti</Link>.
      </p>
      <h4>10. PRAVO INTELEKTUALNOG VLASNIŠTVA</h4>
      <p>
        10.1. Sav sadržaj na internetskoj stranici, uključujući tekstove, slike,
        logotipe, grafike i softver, vlasništvo je Lumena ili licenciran od
        strane trećih strana. Korištenje sadržaja u komercijalne svrhe bez
        izričite dozvole Lumena strogo je zabranjeno.
        <br />
        10.2. Poduke i pripreme smatraju se autorskim djelom te su vlasništvo
        Lumena, odnosno instruktora. Korisniku je dozvoljeno snimanje plaćenog
        sata poduka i priprema u obliku video zapisa isključivo za vlastitu
        upotrebu. Takva snimka namijenjena je isključivo osobnoj uporabi
        Korisnika i ne smije se dijeliti s trećim stranama niti s javnošću.
        <br />
        Svako dijeljenje snimljenog sadržaja s javnošću, uključujući, ali ne
        ograničavajući se na dijeljenje putem interneta ili bilo koje druge
        platforme, predstavlja kršenje autorskih prava. Takvo kršenje za sobom
        povlači pravne posljedice, uključujući mogućnost pokretanja postupka za
        zaštitu autorskih prava i zahtjeva za naknadu štete od strane Lumena ili
        instruktora.
      </p>
      <h4>11. RJEŠAVANJE SPOROVA</h4>
      <p>
        11.1. Svi sporovi koji proizlaze iz korištenja usluga stranke će
        pokušati riješiti mirnim putem kroz pregovore u dobroj vjeri. Ako se
        spor ne može riješiti mirnim putem unutar 30 dana od početka pregovora,
        svaka strana može pokrenuti postupak pred nadležnim sudom.
      </p>
    </>
  );
}

export default TermsAndConditionsPage;
